import { Box, Paper, Stack, Typography } from '@mui/material';

import { MyButton, SectionHeader } from '../uiComponents';

interface PropertyAdCreationMethodProps {
  onManual: () => void;
}

const unavailableMethods = ['Text', 'PDF', 'Excel'] as const;

const methodItemSx = {
  alignItems: { xs: 'stretch', sm: 'center' },
  backgroundColor: '#fff',
  border: '1px solid #dce9f7',
  borderRadius: 2,
  boxShadow: '0 4px 16px rgba(42, 56, 66, 0.08)',
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  gap: 2.5,
  justifyContent: 'space-between',
  minWidth: 0,
  padding: 2.5,
} as const;

export const PropertyAdCreationMethod = ({ onManual }: PropertyAdCreationMethodProps) => (
  <Box
    aria-labelledby='property-ad-creation-method-title'
    component='section'
    minWidth={0}
    width='100%'
  >
    <SectionHeader title='Create a new listing' />
    <Stack paddingY={3}>
      <Stack marginBottom={2.5} spacing={1}>
        <Typography
          color='#2a3842'
          component='h1'
          id='property-ad-creation-method-title'
          variant='h5'
        >
          Choose a creation method
        </Typography>
        <Typography color='#6f7d87' component='p' fontSize={15} fontWeight={400} variant='body2'>
          Start manually now. More import options will be available later.
        </Typography>
      </Stack>

      <Stack component='ul' spacing={1.5} sx={{ listStyle: 'none', margin: 0, padding: 0 }}>
        <Paper component='li' elevation={0} sx={methodItemSx}>
          <Stack spacing={0.75}>
            <Typography color='#2a3842' component='h2' fontSize={18} variant='h6'>
              Manual
            </Typography>
            <Typography color='#6f7d87' component='p' fontWeight={400} variant='body2'>
              Enter the listing information in the PropertyAd Editor.
            </Typography>
          </Stack>
          <MyButton
            data={{
              buttonName: 'Manual',
              buttonType: 'button',
              customWidth: '150px',
              variant: 'contained',
            }}
            onClick={onManual}
          />
        </Paper>

        {unavailableMethods.map((method) => (
          <Paper component='li' elevation={0} key={method} sx={methodItemSx}>
            <Stack spacing={0.75}>
              <Typography color='#2a3842' component='h2' fontSize={18} variant='h6'>
                {method}
              </Typography>
              <Typography color='#6f7d87' component='p' fontWeight={400} variant='body2'>
                Coming soon
              </Typography>
            </Stack>
            <MyButton
              data={{
                buttonName: method,
                buttonType: 'button',
                customWidth: '150px',
                variant: 'outlined',
              }}
              disabled
            />
          </Paper>
        ))}
      </Stack>
    </Stack>
  </Box>
);
